<app-sidebar (toggleEmitter)="toggle()"></app-sidebar>

<section>
    <div id="wrapper" [ngClass]="{ 'active': showSidebar == false }">
        <div id="page-wrapper">
            <div class="page-content fade-in-up">
                <div class="row page-titles">
                    <div class="col-md-5 align-self-center">
                        <h3 class="text-themecolor">Applications</h3>
                    </div>
                    <div class="col-md-7 align-self-center">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item" title="Home">
                                <a [routerLink]="['/dashboard']">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Applications</li>
                            <li class="breadcrumb-item active" style="cursor: pointer;" (click)="goToForm()">Back</li>
                        </ol>
                    </div>
                </div>
                <!-- Filter Button -->
                <div class="filter-button-container">
                    <button class="btn btn-primary" (click)="toggleFilterSidebar()">
                        <i class="fa fa-filter"></i> &nbsp;Filter
                    </button>
                </div>

                <!-- Filter Sidebar -->
                <div class="filter-sidebar" [class.active]="filterSidebarOpen">
                    <div class="filter-sidebar-header">
                        <h4>Filter Requests</h4>
                        <!-- Close button without reset -->
                        <button class="btn-close" (click)="toggleFilterSidebar()">×</button>
                    </div>

                    <div class="filter-sidebar-body">
                        <!-- Module -->
                        <label>Search by Module</label>
                        <select id="moduleid" class="form-control" [(ngModel)]="selectedModuleId"
                            [ngModelOptions]="{ standalone: true }">
                            <option [ngValue]="0">All Modules</option>
                            <option *ngFor="let module of approval_level_by_user_id_data"
                                [ngValue]="module.approval_module_id">
                                {{ module.approval_module_name }}
                            </option>
                        </select>

                        <!-- Status -->
                        <label>Status</label>
                        <select id="statusFilter" class="form-control" [(ngModel)]="selectedStatus">
                            <option [ngValue]="-9999">All</option>
                            <option [ngValue]="0">Pending</option>
                            <option [ngValue]="1">Approved</option>
                            <option [ngValue]="2">Rejected</option>
                        </select>

                        <!-- Keyword -->
                        <div class="form-group">
                            <label>Keyword</label>
                            <input type="text" class="form-control" [(ngModel)]="filterKeyword"
                                placeholder="Search by keyword">
                        </div>

                        <!-- Dates -->
                        <div class="form-group">
                            <label>From Date</label>
                            <input type="date" class="form-control" [(ngModel)]="filterFromDate">
                        </div>

                        <div class="form-group">
                            <label>To Date</label>
                            <input type="date" class="form-control" [(ngModel)]="filterToDate">
                        </div>

                        <!-- Buttons -->
                        <div class="filter-sidebar-footer">
                            <button class="btn btn-primary" (click)="applyFilter()">Apply</button>
                            <button class="btn btn-secondary" (click)="resetFilter()">Reset</button>
                        </div>
                    </div>
                </div>




                <!-- Table -->
                <div class="ibox">
                    <div class="ibox-body">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Sno</th>
                                        <th>Employee Name</th>
                                        <th>Module</th>
                                        <th>Status</th>
                                        <th>Created On</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let req of (filteredRequests || pendingRequests)
            | paginate: { itemsPerPage: pageSize, currentPage: page, totalItems: totalRecords }; let i = index">
                                        <td>{{ (page - 1) * pageSize + i + 1 }}</td>
                                        <td>{{ req.request_name }}</td>
                                        <td>{{ req.module_name }}</td>
                                        <td>
                                            <span [ngClass]="{
          'badge badge-warning': req.status == 0,
          'badge badge-success': req.status == 1,
          'badge badge-danger': req.status == 2
        }">
                                                {{ req.status == 0 ? 'Pending' : req.status == 1 ? 'Approved' :
                                                'Rejected'
                                                }}
                                            </span>
                                        </td>
                                        <td>{{ req.created_on }}</td>
                                        <td>
                                            <button class="btn btn-primary btn-sm"
                                                (click)="openModal(req)">View</button>
                                        </td>
                                    </tr>

                                    <tr *ngIf="pendingRequests?.length == 0">
                                        <td colspan="6" class="text-center">No request found.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mt-3">
                            <div>
                                Showing {{ (page - 1) * pageSize + 1 }}
                                to {{ Math.min(page * pageSize, totalRecords) }}
                                of {{ totalRecords }} entries
                            </div>

                            <pagination-controls (pageChange)="page = $event" autoHide="true" previousLabel="Prev"
                                nextLabel="Next" class="my-pagination">
                            </pagination-controls>
                        </div>

                        <!-- Request Preview Modal -->
                        <div *ngIf="showModal" class="custom-modal-overlay" (click)="closeModal()">
                            <div class="custom-modal" (click)="$event.stopPropagation()">

                                <!-- Header -->
                                <div class="modal-header d-flex align-items-center justify-content-between">
                                    <h4 class="modal-title mb-0 col-md-11">📄 Application Preview</h4>&nbsp;
                                    <button type="button" class="btn-close" aria-label="Close"
                                        (click)="closeModal()">×</button>
                                </div>

                                <!-- Body -->
                                <div class="modal-body pt-2">
                                    <form *ngIf="selectedRequest">
                                        <table class="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th colspan="2">Data</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let field of selectedRequest.fields">
                                                    <td><strong>{{ field.name }}</strong></td>
                                                    <!-- Table Data -->
                                                    <!-- Table Data -->
                                                    <ng-container *ngIf="isTableData(field.value); else fileOrText">
                                                        <div class="table-responsive">
                                                            <table class="table table-sm table-bordered mb-0">
                                                                <thead class="thead-light">
                                                                    <!-- Header Row 1: Main Headers -->
                                                                    <tr>
                                                                        <ng-container
                                                                            *ngFor="let col of getTableHeaders(field.value)">
                                                                            <th [attr.rowspan]="col.rowspan"
                                                                                [attr.colspan]="col.colspan"
                                                                                class="text-center align-middle">
                                                                                {{ col.header }}
                                                                            </th>
                                                                        </ng-container>
                                                                    </tr>
                                                                    <!-- Header Row 2: Sub Headers -->
                                                                    <tr>
                                                                        <ng-container
                                                                            *ngFor="let col of getTableHeaders(field.value)">
                                                                            <ng-container *ngIf="!col.isSimple">
                                                                                <th *ngFor="let sub of col.subHeaders">
                                                                                    {{ sub.label }}
                                                                                </th>
                                                                            </ng-container>
                                                                        </ng-container>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr *ngFor="let row of field.value">
                                                                        <ng-container
                                                                            *ngFor="let col of getTableHeaders(field.value)">
                                                                            <!-- Simple Column -->
                                                                            <td *ngIf="col.isSimple">{{ row[col.dataKey]
                                                                                }}</td>

                                                                            <!-- Nested Columns -->
                                                                            <ng-container *ngIf="!col.isSimple">
                                                                                <td *ngFor="let sub of col.subHeaders">
                                                                                    {{ row[sub.key] }}
                                                                                </td>
                                                                            </ng-container>
                                                                        </ng-container>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #fileOrText>
                                                        <td>
                                                            <!-- File -->
                                                            <ng-container
                                                                *ngIf="getFileObject(field.value) as fileData; else textField">

                                                                <!-- Image -->
                                                                <div *ngIf="fileData.mime.startsWith('image/')">
                                                                    <a [href]="fileData.url || ('data:' + fileData.mime + ';base64,' + fileData.base64)"
                                                                        target="_blank">
                                                                        <img [src]="fileData.url || ('data:' + fileData.mime + ';base64,' + fileData.base64)"
                                                                            [alt]="fileData.fileName"
                                                                            class="img-fluid rounded border"
                                                                            style="max-height: 150px;" />
                                                                    </a>
                                                                </div>

                                                                <!-- PDF -->
                                                                <div *ngIf="fileData.mime === 'application/pdf'">
                                                                    <a [href]="fileData.url || ('data:application/pdf;base64,' + fileData.base64)"
                                                                        [download]="fileData.fileName" target="_blank"
                                                                        class="btn btn-sm btn-outline-primary">
                                                                        📄 {{ fileData.fileName }}
                                                                    </a>
                                                                </div>
                                                            </ng-container>

                                                            <!-- Text -->
                                                            <ng-template #textField>
                                                                <span>{{ formatFieldValue(field.value) }}</span>
                                                            </ng-template>
                                                        </td>
                                                    </ng-template>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </form>
                                </div>

                                <!-- Footer -->
                                <div class="modal-footer d-flex justify-content-end">

                                    <!-- Show Approve / Approve+Forward buttons only if status is Pending -->
                                    <ng-container *ngIf="selectedRequest?.status == 0">

                                        <!-- Case 1: reporting_to_level == applicationlevel  -->
                                        <button
                                            *ngIf="selectedRequest.reporting_to_level == selectedRequest.applicationlevel"
                                            class="btn btn-success" (click)="updateRequestStatus(selectedRequest, 1)">
                                            ✅ Approve
                                        </button>

                                        <!-- Case 2: template_mode = 'strict' AND applicationlevel < reporting_to_level -->
                                        <ng-container
                                            *ngIf="selectedRequest.template_mode === 'strict' && selectedRequest.applicationlevel < selectedRequest.reporting_to_level">
                                            <button class="btn btn-primary"
                                                (click)="updateRequestStatus(selectedRequest, 0)">
                                                ⏩ Approve & Send Forward
                                            </button>
                                        </ng-container>

                                        <!-- Case 3: template_mode = 'flexible' AND applicationlevel < reporting_to_level -->
                                        <ng-container
                                            *ngIf="selectedRequest.template_mode === 'flexible' && selectedRequest.applicationlevel < selectedRequest.reporting_to_level">
                                            <button class="btn btn-success"
                                                (click)="updateRequestStatus(selectedRequest, 1)">
                                                ✅ Approve
                                            </button>
                                            <button class="btn btn-primary"
                                                (click)="updateRequestStatus(selectedRequest, 0)">
                                                ⏩ Approve & Send Forward
                                            </button>
                                        </ng-container>

                                    </ng-container>

                                    <!-- Reject always available if status is Pending -->
                                    <button *ngIf="selectedRequest?.status == 0" class="btn btn-danger"
                                        (click)="updateRequestStatus(selectedRequest, 2)">
                                        ❌ Reject
                                    </button>

                                    <button class="btn btn-secondary" (click)="closeModal()">Close</button>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>